module.exports = __webpack_public_path__ + "static/img/com0.3a2c983.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/product/components/imgs/com0.jpg
// module id = Y7em
// module chunks = 1